var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilemessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.21366 4.19971C4.05136 4.19971 3.91968 4.3408 3.91968 4.51471C3.91968 4.68861 4.05136 4.8297 4.21366 4.8297H12.0531C12.2154 4.8297 12.3471 4.68861 12.3471 4.51471C12.3471 4.3408 12.2154 4.19971 12.0531 4.19971H4.21366Z",
    fill: "url(#paint0_linear_3283_16167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.91968 6.6148C3.91968 6.4409 4.05136 6.2998 4.21366 6.2998H12.0531C12.2154 6.2998 12.3471 6.4409 12.3471 6.6148C12.3471 6.78871 12.2154 6.9298 12.0531 6.9298H4.21366C4.05136 6.9298 3.91968 6.78871 3.91968 6.6148Z",
    fill: "url(#paint1_linear_3283_16167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.21366 2.1001C4.05136 2.1001 3.91968 2.24119 3.91968 2.4151C3.91968 2.589 4.05136 2.73009 4.21366 2.73009H12.0531C12.2154 2.73009 12.3471 2.589 12.3471 2.4151C12.3471 2.24119 12.2154 2.1001 12.0531 2.1001H4.21366Z",
    fill: "url(#paint2_linear_3283_16167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95987 1.36499V4.19998H1.27392C0.570361 4.19998 0 4.81112 0 5.56497V14.1701V14.1799V16.065C0 16.8189 0.570361 17.43 1.27392 17.43H14.993C15.6966 17.43 16.2669 16.8189 16.2669 16.065V14.1808V14.1701V5.56497C16.2669 4.81111 15.6966 4.19998 14.993 4.19998H14.307V1.36499C14.307 0.611139 13.7367 0 13.0331 0H3.23378C2.53023 0 1.95987 0.61114 1.95987 1.36499ZM2.54783 1.36499C2.54783 0.95894 2.85482 0.629998 3.23378 0.629998H13.0331C13.4121 0.629998 13.7191 0.95894 13.7191 1.36499V8.8987L11.8243 11.0258L8.80863 9.00536C8.39522 8.72892 7.87158 8.72892 7.45817 9.00536L4.44251 11.0258L2.54771 8.8987L2.54783 1.36499ZM14.307 8.23825V4.82997H14.993C15.372 4.82997 15.679 5.15892 15.679 5.56497V6.69863L14.307 8.23825ZM1.95987 4.82997V8.23825L0.587961 6.69854V5.56489C0.587961 5.15883 0.894955 4.82989 1.27392 4.82989L1.95987 4.82997ZM11.6199 11.6312C11.6306 11.646 11.6413 11.6599 11.6543 11.673C11.6972 11.7173 11.75 11.7444 11.8044 11.7551L15.679 14.3496V16.0649C15.679 16.4709 15.372 16.7999 14.9931 16.7999H1.27399C0.895033 16.7999 0.588039 16.4709 0.588039 16.0649V14.3496L4.4627 11.7551C4.51706 11.7444 4.56988 11.7173 4.61275 11.673C4.62577 11.6599 4.63648 11.646 4.6472 11.6312L7.77006 9.54025C7.99284 9.39095 8.27457 9.39095 8.49735 9.54025L11.6199 11.6312ZM12.3334 11.3662L15.6789 7.61084V13.6065L12.3334 11.3662ZM0.587883 7.61084L3.93338 11.3662L0.587883 13.6065V7.61084Z",
    fill: "url(#paint3_linear_3283_16167)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_16167",
    x1: 8.31915,
    y1: 4.85068,
    x2: 8.2862,
    y2: 4.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_16167",
    x1: 8.31915,
    y1: 6.95078,
    x2: 8.2862,
    y2: 6.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3283_16167",
    x1: 8.31915,
    y1: 2.75107,
    x2: 8.2862,
    y2: 2.32349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3283_16167",
    x1: 8.49202,
    y1: 18.0105,
    x2: 2.57128,
    y2: 12.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilemessage);
export default __webpack_public_path__ + "static/media/profilemessage.62483704c93c951f37f3477c5069eb3e.svg";
export { ForwardRef as ReactComponent };